import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RsaPreviewData } from '../../../../../../../models/google-template/preview-interfaces/rsa-preview-data.interface';

/**
 * Presentational mobile SERP mock for the Google RSA Search preview. Renders
 * the flat {@link RsaPreviewData} DTO only — all block reading lives in the
 * shell ({@link GoogleRsaPreviewComponent}). Mobile adds the phone-call row and
 * drops the desktop tabs.
 */
@Component({
    selector: 'app-rsa-google-mobile-01',
    imports: [CommonModule],
    templateUrl: './rsa-google-mobile-01.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './rsa-google-mobile-01.component.scss'
})
export class RsaGoogleMobile01PreviewComponent {
  @Input() data!: RsaPreviewData;
}
